/**
 * Analytics event constants
 * Centralized location for all analytics tracking event names
 */

export const ANALYTICS_EVENTS = {
  // GLCE (Greenlight for Classrooms Educators) Events
  GLCE_PRESENTATION_DOWNLOADED: 'GLCE Presentation Downloaded',
  GLCE_WORKSHOP_DETAILS_SUBMITTED: 'GLCE Workshop Details Submitted',

  // Lesson Plan Events
  LESSON_PLAN_DOWNLOADED: 'Lesson Plan Downloaded'
} as const;

// Type for analytics events (optional, for type safety)
export type AnalyticsEvent =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
